import * as React from "react";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

const CustomSwitch = (props) => {
    const { id, label, onChange, value } = props;

    const handleChange = (event) => {
        let newValue = event.target.checked;
        onChange({ id: id, value: newValue });
    };

    return (
        <FormGroup>
            <FormControlLabel control={<Switch size="small" checked={value} onChange={handleChange} />} label={label} />
        </FormGroup>
    );
};

export { CustomSwitch };
